import React, { useState } from "react";
import LayoutHOC from "../LayoutHOC";
import Select from "../../components/UniversalComponents/SelectComponent";
import Button from "../UniversalComponents/DefaultButton";
import Input from "../UniversalComponents/InputComponent";
import { ReactComponent as DownAngelBracket } from "../../assets/images/downAngleBracket.svg";
import { ReactComponent as CalendarWithTimeIcon } from "../../assets/images/calendarWithTimeIcon.svg";
import DatePicker from "react-datepicker";
import TableComponent from "../UniversalComponents/TableComponent";
import VendorHeaderHoc from "./VendorHeaderHoc";
import { number } from "yup";

const VendorCredit = () => {
  const selectVendoer = [
    { label: "Who did you Pay ?" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const handleButtonClickAmount = () => {};
  const handleButtonClickClearLines = () => {};

  const handleButtonClickAddLines = () => {};
  const handleButtonClickCancel = () => {};
  const handleButtonClickSave = () => {};

  const [selectedValue, setSelectedValue] = useState("");

  const [inputValue, setInputValue] = useState("");
  const [inputRefValue, setInputRefValue] = useState("");
  const [inpuTagValue, setInputTagValue] = useState("");
  const [isTableOpen, setIsTableOpen] = useState(false);

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleMailInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleRefInputChange = (e) => {
    setInputRefValue(e.target.value);
  };
  const handleTAgInputChange = (e) => {
    setInputTagValue(e.target.value);
  };

  const [paymentDate, setPaymentDate] = useState(null);

  const placeholder = "Enter Detail";
  const displayFormat = "dd-MM-yyyy";

  const formatDateForSave = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    return `${day}-${month}-${year}`;
  };

  const onChange = (date) => {
    setPaymentDate(date);

    const formattedPaymentDate = date ? formatDateForSave(date) : "";

    // FieldChange({ payment_date: formattedPaymentDate });
  };

  const [isTableVisible, setIsTableVisible] = useState(false);
  const [isCTTableVisible, setCTIsTableVisible] = useState(true);

  const toggleTableVisibility = (e) => {
    e.preventDefault();
    setIsTableVisible((prev) => !prev);
    setIsTableOpen((prevState) => !prevState);
  };
  const toggleCTableVisibility = (e) => {
    e.preventDefault();
    setCTIsTableVisible((prev) => !prev);
  };

  return (
    <form className="bg-F1F6F9">
      <div className="px-10">
        <div>
          <div className="flex flex-col bg-F1F6F9 gap-y-[20px]">
            <div className="w-full flex justify-between space-x-4">
              <div className="w-[90%] bg-white p-4 m border  rounded">
                <div className="flex gap-2 my-2 w-full justify-between  ">
                  <div className="w-full">
                    <div className="text-14 text-434852 font-400">Vendor</div>
                    <div className="w-full">
                      <Select
                        name="vendorselect"
                        options={selectVendoer} // Pass the options array
                        value={selectedValue} // Bind the selected value to the state
                        onChange={handleSelectChange} // Handle the change event
                        style={{
                          width: "100%",
                          height: "35px",
                          padding: "5px",
                        }}
                        className="w-full"
                      ></Select>
                    </div>
                  </div>
                  <div className="w-full">
                    <div className="text-14  text-434852 font-400">Mailing Address</div>
                    <div>
                      <Input
                        name="reference"
                        placeholder="abc@gmail.com"
                        value={inputValue} // Bind the input value to the state
                        onChange={handleMailInputChange} // Handle the change event
                        style={{ width: "", height: "35px" }} // Additional styling if needed
                      ></Input>
                    </div>
                  </div>
                  <div className="w-full">
                    <div className="text-14 text-434852 font-400">Payment Date</div>
                    <div className="flex items-center bg-white   datePicker_container ">
                      <DatePicker
                        selected={paymentDate}
                        onChange={onChange}
                        paymentDate={paymentDate}
                        // endDate={endDate}
                        // selectsRange
                        placeholderText={placeholder}
                        dateFormat={displayFormat}
                        className=" w-[100%] flex-grow  rounded focus:outline-hidden focus:ring-0    active:border active:border-DFE2E5 text-gray-800 text-sm  h-[34px]  border border-gray-200"
                      ></DatePicker>

                      <div>
                        <CalendarWithTimeIcon></CalendarWithTimeIcon>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-[66.5%] flex justify-between items- gap-2 py-2">
                  <div className="w-full">
                    <div className="text-14  text-434852 font-400">Ref. No.</div>
                    <div>
                      <Input
                        name="vendormail"
                        label="Enter Text"
                        type={"number"}
                        value={inputRefValue} // Bind the input value to the state
                        onChange={handleRefInputChange} // Handle the change event
                        style={{ width: "", height: "35px" }} // Additional styling if needed
                      ></Input>
                    </div>
                  </div>
                  <div className="w-full">
                    <div className=" ">
                      <div className="text-14 text-434852 font-400">Tags</div>

                      <div>
                        <Input
                          name="vendorTag"
                          label="Enter Text"
                          placeholder="Start Typing To Add A Tag"
                          value={inpuTagValue} // Bind the input value to the state
                          onChange={handleTAgInputChange} // Handle the change event
                          style={{ width: "100%", height: "35px" }} // Additional styling if needed
                        ></Input>
                      </div>
                      <div className="text-009CBF text-12 font-400 pt-2 ">Manage Tags</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" bg-FFFFFF border rounded flex flex-col justify-center items-center px-5">
                <div className="bg-0093C1  px-10 py-2 border rounded flex flex-col justify-center items-center w-full whitespace-nowrap">
                  <div className="text-center text-16 font-400 capitalize text-FFFFFF">Available Amount</div>
                  <div>
                    <div className="space-x-1">
                      <span className="text-30 text-FFFFFF font-500 ">$ 0.00</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="">
              <div className="flex items-center justify-start space-x-2 pb-[8px]">
                <div className="text-18 font-600 text-1D4469">Category Details</div>
                <div>
                  <button
                    onClick={(e) => {
                      toggleCTableVisibility(e);
                    }}
                  >
                    <DownAngelBracket
                      className={`h-[8px] text-1D4469 sidedownarrow  items-center ${isCTTableVisible ? "" : "rotate-180"}`}
                    />
                  </button>
                </div>
              </div>
              <div>
                {isCTTableVisible && (
                  <div className="pt-[10px]">
                    <TableComponent name="categoryDetails" />
                  </div>
                )}
              </div>
            </div>
            <div className="">
              <div className="flex items-center justify-start space-x-2">
                <div className="text-18 font-600 text-1D4469">Item Details</div>
                <div>
                  <button
                    onClick={(e) => {
                      toggleTableVisibility(e);
                    }}
                  >
                    <DownAngelBracket
                      className={`h-[8px] text-1D4469 sidedownarrow  items-center ${isTableOpen ? "" : "rotate-180"}`}
                    />
                  </button>
                </div>
              </div>
              {isTableVisible && (
                <div className="pt-[10px]">
                  <TableComponent name="itemDetails" />
                </div>
              )}
            </div>
            <div className="flex flex-col gap-y-[15px]">
              <div className="bg-FFFFFF border rounded 1px solid">
                <div className="w-[66.5%]  p-[20px]">
                  <div className="flex items-center justify-between gap-[9px]  mb-6 w-full">
                    <div className="w-full">
                      <div className="text-14 font-400 text-434852 mb-1">Memo</div>
                      <div className="h-[140px] text-14 font-400 ">
                        <textarea
                          rows="6"
                          // cols="76"
                          placeholder=""
                          className="w-full focus:outline-hidden focus:ring-0 active:border active:border-DFE2E5 text-gray-800 text-sm  border border-gray-200"
                        />
                      </div>
                    </div>
                    <div className="w-full text-434852">
                      <div className="space-x-2 flex justify-between items-center ">
                        <div className="space-x-2">
                          <span className=" text-14 font-600">Attachments(0)</span>
                          <span className="text-14 font-400">Maximum Size 20 MB</span>
                        </div>
                      </div>
                      <div className="h-[140px] border rounded text-12 font-400  ">
                        <div className="flex flex-col items-center justify-center h-full w-full text-center">
                          <div className="text-AFAFAF">Drop files here or click to select from the device</div>
                          <div className="flex bg-F4F4F4  justify-between items-center p-3 m-2 border rounded">
                            <div className="text-[11px] font-500">Upload from this device</div>
                            <div>
                              <DownAngelBracket />
                            </div>
                          </div>
                        </div>
                        <div className="pt-2 text-12 font-400 text-009CBF">Show Existing</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center ">
                <div className=" flex justify-start items-center gap-x-4 ">
                  <div className="text-12 font-400 text-009CBF">Privacy</div>
                  <div className="text-12 font-400 text-009CBF">Make Recurring</div>
                </div>
                <div className="flex justify-end items-center gap-x-[10px]">
                  <div className="bg-D4EAEE m-[1px] p-[3px] h-[35px] border-non rounded ">
                    <div className="flex items-center justify-between px-2 w-[284px] text-2C495D">
                      <span className="text-16 font-600">Total</span>
                      <span className="text-18 font-600 ">$ 0.00</span>
                    </div>
                  </div>
                  <div className="flex justify-between items-center gap-x-[10px] py-4">
                    <div>
                      <Button
                        type="primary" // Pass the type as "primary" or "secondary"
                        onClick={handleButtonClickCancel} // Handle click event
                        style={{}}
                      >
                        CANCEL
                      </Button>
                    </div>
                    <div>
                      <Button
                        type="secondary"
                        onClick={handleButtonClickSave}
                        style={{
                          marginRight: "0px",
                        }}
                      >
                        SAVE
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default LayoutHOC(VendorHeaderHoc(VendorCredit));
